'use strict';
import $ from 'jquery';
import Cookies from 'js-cookie';

export default class Banner {
    static init() {
        new Banner();
    }

    constructor() {
        this.COOKIE_EXPIRATION = 30; // cookie epxires in 30 days
        this.COOKIE_NAME = "opensystems-banner";
        this.banner = $('section.announcement-banner');
        this.banner.on('click', 'a.close', this.close.bind(this));
        if (this.banner.hasClass('enabled')) {
            $(window).trigger('resize');
            if (!Cookies.get(this.COOKIE_NAME))
                setTimeout(() => {
                    this.banner.slideDown(() => {
                        if (this.banner.find('.banners a').length > 1) {
                            this.banner.find('.banners').slick({
                                rows: 0
                            });
                        }
                    });
                }, 500);
        }
    }

    close() {
        this.banner.slideUp();
        Cookies.set(this.COOKIE_NAME, "1", { expires: this.COOKIE_EXPIRATION });
    }
}